import { menuReducer } from "../reducer/MenuListReducer";

export const reducer = menuReducer;
